import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#626C9D",
      d: "M16.667 13.333a2.5 2.5 0 0 1-2.5 2.5H5.833a2.5 2.5 0 0 1-2.5-2.5V9.167h13.334zm-10-1.666a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666m3.333 0a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666m3.333 0a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666M12.917 2.5c.69 0 1.25.56 1.25 1.25v.417a2.5 2.5 0 0 1 2.5 2.5V7.5H3.333v-.833a2.5 2.5 0 0 1 2.5-2.5V3.75a1.25 1.25 0 0 1 2.5 0v.417h3.334V3.75c0-.69.56-1.25 1.25-1.25"
    }, null, -1)
  ])))
}
export default { render: render }